'use client';

import { getClientNewUserTrial } from '@/app/services/cart';
import { getNewUserTrialPoints } from '@/lib/new-user-trial';
import { useQuery } from '@tanstack/react-query';

export function useNewUserTrial() {
  const query = useQuery({
    queryKey: ['new-user-trial-plan'],
    queryFn: async () => {
      const { data } = await getClientNewUserTrial();
      return data;
    },
  });

  return {
    ...query,
    points: getNewUserTrialPoints(query.data),
  };
}
